import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { LenderType } from "Globals/Models/LenderType";
import { LendersEnum } from "Globals/Models/LendersEnum";

export class LenderTypeStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private lenderTypes: LenderType[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.lenderTypes = initialState.lenderTypes;
    }

    @MobX.action
    public getLendersName(lenderId: string | null): string {
        if (lenderId == null) return "";
        let lender = this.getSortedByOrdinal.find((lender) => lenderId === lender.id);
        return lender ? lender.name : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): LenderType[] {
        return this.lenderTypes.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getLenderTypeOptions(): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "0",
        } as KeyValuePair;

        let options = this.getSortedByOrdinal.map((lender) => ({ value: lender.id, key: lender.name })) as KeyValuePair[];

        options.unshift(placeholder);

        return options;
    }
}
